// extracted by mini-css-extract-plugin
module.exports = {"option":"selectsettings_option__2lE4q","inputLabel":"selectsettings_inputLabel__GHniT","add":"selectsettings_add__2Ref2"};